import { fromJS, getIn, Record, RecordOf, List, Map } from 'immutable';

// CONSTANTS
import { ENTITY_IDS_BY_NAME } from 'constants/common';
import { DEFAULT_PER_PAGE, DEFAULT_OFFSET } from 'constants/table';
import { HistoryAction, HistoryCategory, VEHICLE_TABS } from 'constants/vehicles';
import {
  ADD_FILTER,
  ADD_DAMAGE_FAIL,
  ADD_DAMAGE_SUCCESS,
  ADD_DAMAGE_PICTURE_FAIL,
  ADD_DAMAGE_PICTURE_SUCCESS,
  ADD_VEHICLE_FAIL,
  ADD_VEHICLE_SUCCESS,
  CHANGE_PER_PAGE_VALUE,
  CHANGED_OWNER_FAIL,
  CHANGED_OWNER_SUCCESS,
  CLEAR_FILTERS,
  CLEAR_VEHICLE,
  CLEAR_VEHICLE_ERRORS,
  CREATE_AGREEMENT_FAIL,
  GET_DEPARTMENTS_FAIL,
  GET_DEPARTMENTS_SUCCESS,
  GET_HISTORY_FAIL,
  GET_HISTORY_SUCCESS,
  GET_STATUSES_FAIL,
  GET_STATUSES_SUCCESS,
  GET_VEHICLE_FAIL,
  GET_VEHICLE_SUCCESS,
  GET_VEHICLES_FAIL,
  GET_VEHICLES_LIGHT_FAIL,
  GET_VEHICLES_LIGHT_SUCCESS,
  GET_VEHICLES_SUCCESS,
  START_LOADING_DASHBOARD_VEHICLES,
  GET_DASHBOARD_VEHICLES_SUCCESS,
  GET_DASHBOARD_VEHICLES_FAIL,
  REFRESH_CONNECTED_DATA_FAIL,
  REFRESH_CONNECTED_DATA_SUCCESS,
  REFRESH_FUEL_SUCCESS,
  REFRESH_ODOMETER_SUCCESS,
  REMOVE_DAMAGE_FAIL,
  REMOVE_DAMAGE_SUCCESS,
  REMOVE_DAMAGE_PICTURE_FAIL,
  REMOVE_DAMAGE_PICTURE_SUCCESS,
  REMOVE_FILTER,
  RESET_VEHICLES_DATA,
  SELECT_VIEW,
  SET_ACTIVE_TAB,
  SET_CALENDAR_START,
  SET_COLUMNS,
  SET_DAMAGES_FAIL,
  SET_DAMAGES_SUCCESS,
  SET_ODOMETER_OFFSET_FAIL,
  SET_ODOMETER_OFFSET_SUCCESS,
  SET_SEARCH_QUERY,
  SET_VEHICLE,
  SET_VEHICLES_OFFSET,
  START_LOADING,
  START_LOADING_LIGHT_VEHICLES,
  START_LOADING_VEHICLES,
  START_REFRESH_FUEL_LOADING,
  START_REFRESH_ODOMETER_LOADING,
  UPDATE_DAMAGE_FAIL,
  UPDATE_DAMAGE_SUCCESS,
  UPDATE_VEHICLE_FAIL,
  UPDATE_VEHICLE_SUCCESS,
  REFRESH_BATTERY_SUCCESS,
  START_REFRESH_BATTERY_LOADING,
  SET_FILTERS,
} from './actions';
import {
  CREATE_VIEW_SUCCESS,
  DELETE_VIEW_SUCCESS,
  GET_USER_VIEWS_SUCCESS,
  UPDATE_VIEW_SUCCESS,
} from 'services/Views/actions';
import { GENERIC_ERROR } from 'constants/errors.constants';

// SERVICES
import {
  VehicleHistoryAgreementChangeRecord,
  VehicleHistoryDetailsChangeRecord,
  VehicleHistoryGeofenceBreachRecord,
  VehicleHistoryNoteAddedRecord,
  VehicleHistoryRecord,
  VehicleHistoryUnitTypeChangeRecord,
  VehicleHistoryUser,
  VehicleHistoryVehicle,
  VehicleRecord,
} from './factories';
import { Vehicle, VehicleDepartment } from 'services/resources';
import { withLatestRequest } from 'services/latestRequest';

const GENERIC_CONNECTED_DATA_ERROR = {
  message: { translationId: 'errors.couldNotRefreshConnectedVehicle' },
};

const VehiclesRecord = Record({
  activeTab: VEHICLE_TABS.table,
  activeView: undefined,
  calendarStart: undefined,
  columns: List(),
  dashboardVehicles: Map(),
  departments: List<RecordOf<VehicleDepartment>>(),
  errors: Record({})(),
  filters: List(),
  history: List<VehicleHistoryRecord>(),
  loading: false,
  loadingDashboardVehicles: false,
  loadingLightVehicles: false,
  loadingVehicles: false,
  offset: DEFAULT_OFFSET,
  perPage: DEFAULT_PER_PAGE,
  refreshFuelLoading: false,
  refreshBatteryLoading: false,
  refreshOdometerLoading: false,
  requestId: 0,
  searchQuery: undefined,
  statuses: List(),
  total: 0,
  vehicle: VehicleRecord(),
  vehicles: List<List<RecordOf<Vehicle>>>(),
  vehiclesMap: List(),
  views: undefined,
});

function vehiclesServiceReducer(state = VehiclesRecord(), action) {
  switch (action.type) {
    case ADD_FILTER:
      return (
        state
          .update('filters', (filters) => filters.push(fromJS(action.payload.filter)))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case SET_FILTERS:
      return state.set('filters', action.payload.filters);
    case ADD_DAMAGE_FAIL:
    case ADD_DAMAGE_PICTURE_FAIL:
    case REMOVE_DAMAGE_FAIL:
    case REMOVE_DAMAGE_PICTURE_FAIL:
    case UPDATE_DAMAGE_FAIL:
      return state.merge({
        loading: false,
        // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
        errors: fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR),
      });
    case ADD_DAMAGE_PICTURE_SUCCESS: {
      const damageIndex = state
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        .getIn(['vehicle', 'damages'], [])
        // @ts-expect-error TS(2339): Property 'findIndex' does not exist on type 'unkno... Remove this comment to see the full error message
        .findIndex((damage) => damage.id === action.payload.damageId);

      return state
        .merge({
          loading: false,
          // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
          errors: fromJS({}),
        })
        .updateIn(['vehicle', 'damages', damageIndex, 'pictures'], (damagesPictures) =>
          // @ts-expect-error TS(2339): Property 'concat' does not exist on type 'unknown'... Remove this comment to see the full error message
          damagesPictures.concat(action.payload.pictures)
        );
    }
    case ADD_DAMAGE_SUCCESS:
      return (
        state
          .merge({
            loading: false,
            // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
            errors: fromJS({}),
          })
          // @ts-expect-error TS(2339): Property 'push' does not exist on type 'unknown'.
          .updateIn(['vehicle', 'damages'], (vehiclesDamages) => [...vehiclesDamages, action.payload.damage])
      );
    case ADD_VEHICLE_FAIL:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case ADD_VEHICLE_SUCCESS:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS({}))
          .set('vehiclesMap', fromJS([]))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case CHANGED_OWNER_FAIL:
      return state.set('loading', false);
    case CHANGED_OWNER_SUCCESS: {
      const pageNumber = state.get('offset') / state.get('perPage') + 1;
      const stateVehicles = state.get('vehicles').update(pageNumber, (vehicles) =>
        vehicles.map((vehicle) => {
          if (action.payload.vehicles.includes(vehicle.id)) {
            return { ...vehicle, owner: action.payload.owner };
          }

          return vehicle;
        })
      );

      return state.set('loading', false).set('vehicles', stateVehicles);
    }
    case CHANGE_PER_PAGE_VALUE:
      return (
        state
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('perPage', action.payload.perPage)
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case CLEAR_FILTERS:
      return (
        state
          .set('filters', state.get('activeView') ? state.get('activeView').get('rules') : fromJS([]))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case CLEAR_VEHICLE:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('vehicle', fromJS({})).set('history', List());
    case CLEAR_VEHICLE_ERRORS:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('errors', fromJS({}));
    case CREATE_AGREEMENT_FAIL:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR));
    case CREATE_VIEW_SUCCESS:
      if (action.payload.view.type === ENTITY_IDS_BY_NAME.vehicles) {
        return state
          .set('views', state.get('views').push(fromJS(action.payload.view)))
          .set('activeView', fromJS(action.payload.view));
      }
      return state;
    case DELETE_VIEW_SUCCESS: {
      const index = state.get('views').findIndex((view) => view.get('id') === action.payload.id);

      if (index > -1) {
        return state
          .set('views', state.get('views').remove(index))
          .set('activeView', null)
          .set('filters', fromJS([]))
          .set('columns', fromJS([]));
      }

      return state;
    }
    case GET_DEPARTMENTS_FAIL:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case GET_DEPARTMENTS_SUCCESS:
      return state.set('loading', false).set('departments', fromJS(action.payload.data.results));
    case GET_HISTORY_FAIL:
      return (
        state
          .set('history', List())
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case GET_HISTORY_SUCCESS:
      return (
        state
          .set(
            'history',
            List(
              action.payload.data.map((item) => {
                const itemRecord = {
                  ...item,
                  vehicle: VehicleHistoryVehicle(item.vehicle),
                  user: VehicleHistoryUser(item.user),
                };

                switch (item.category) {
                  case HistoryCategory.DETAILS:
                    return VehicleHistoryDetailsChangeRecord(itemRecord);
                  case HistoryCategory.NOTE:
                    return VehicleHistoryNoteAddedRecord(itemRecord);
                  case HistoryCategory.AGREEMENT:
                    return VehicleHistoryAgreementChangeRecord(itemRecord);
                  case HistoryCategory.GEOFENCE:
                    return VehicleHistoryGeofenceBreachRecord(itemRecord);
                  case HistoryCategory.UNIT_TYPE:
                    return VehicleHistoryUnitTypeChangeRecord(itemRecord);
                  default:
                    return VehicleHistoryDetailsChangeRecord(itemRecord);
                }
              })
            )
          )
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS({}))
      );
    case GET_STATUSES_FAIL:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case GET_STATUSES_SUCCESS:
      return state.set('loading', false).set('statuses', fromJS(action.payload.data.results));
    case GET_USER_VIEWS_SUCCESS: {
      const vehicleViews = fromJS(
        action.payload.views.results.filter((view) => view.type === ENTITY_IDS_BY_NAME.vehicles)
      );
      const defaultView = vehicleViews.find((view) => view.get('isDefault'));
      let activeView = state.get('activeView');
      let filters = state.get('filters');
      let columns = state.get('columns');

      if (!vehicleViews.includes(activeView)) {
        activeView = null;
      }

      if (typeof defaultView !== 'undefined') {
        activeView = defaultView;
        filters = defaultView.get('rules');
        columns = defaultView.get('columns');
      }

      return state
        .set('loading', false)
        .set('views', vehicleViews)
        .set('activeView', activeView)
        .set('filters', filters)
        .set('columns', columns);
    }
    case GET_VEHICLE_SUCCESS: {
      const vehicleId = state.getIn(['vehicle', 'id']);
      let vehicle = VehicleRecord(action.payload.data);

      if (vehicle.get('id') === vehicleId) {
        vehicle = state.get('vehicle').merge(vehicle);
      }
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('loading', false).set('vehicle', vehicle).set('errors', fromJS({}));
    }
    case GET_VEHICLE_FAIL:
      return (
        state
          .set('loading', false)
          .set('refreshOdometerLoading', false)
          .set('refreshFuelLoading', false)
          .set('refreshBatteryLoading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicle', fromJS({}))
      );
    case GET_VEHICLES_FAIL:
      return (
        state
          .set('loadingVehicles', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('perPage', DEFAULT_PER_PAGE)
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case GET_VEHICLES_LIGHT_FAIL:
      return (
        state
          .set('loadingLightVehicles', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
          .set('vehiclesMap', fromJS([]))
      );
    case GET_VEHICLES_LIGHT_SUCCESS:
      return state.set('vehiclesMap', fromJS(action.payload.data.results)).set('loadingLightVehicles', false);
    case START_LOADING_DASHBOARD_VEHICLES:
      return state.set('loadingDashboardVehicles', true);
    case GET_DASHBOARD_VEHICLES_SUCCESS: {
      const byVin = {};
      (action.payload.data.results || []).forEach((vehicle) => {
        if (vehicle.vin) {
          byVin[vehicle.vin.toUpperCase()] = vehicle;
        }
      });
      return state.set('dashboardVehicles', fromJS(byVin)).set('loadingDashboardVehicles', false);
    }
    case GET_DASHBOARD_VEHICLES_FAIL:
      return (
        state
          .set('loadingDashboardVehicles', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case GET_VEHICLES_SUCCESS: {
      const pageNumber = action.payload.offset / state.get('perPage') + 1;
      const vehicles = fromJS(action.payload.data.results);

      return (
        state
          .setIn(['vehicles', pageNumber], vehicles)
          .set('offset', action.payload.offset)
          .set('total', action.payload.data.count)
          .set('loadingVehicles', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS({}))
      );
    }
    case REFRESH_CONNECTED_DATA_FAIL:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_CONNECTED_DATA_ERROR))
      );
    case REFRESH_CONNECTED_DATA_SUCCESS: {
      const vehicle = state.get('vehicle').merge(action.payload.vehicle);

      return state
        .set('vehicle', vehicle)
        .set('refreshOdometerLoading', false)
        .set('refreshFuelLoading', false)
        .set('refreshBatteryLoading', false);
    }
    case REFRESH_FUEL_SUCCESS:
      return state
        .setIn(['vehicle', 'isConnected'], action.payload.isConnected)
        .setIn(['vehicle', 'fuelLevel'], action.payload.fuelLevel)
        .setIn(['vehicle', 'connectedFuelLevel'], action.payload.connectedFuelLevel)
        .setIn(['vehicle', 'fuelLevelDate'], action.payload.fuelLevelDate)
        .setIn(['vehicle', 'fuelLevelStale'], action.payload.fuelLevelStale)
        .set('refreshFuelLoading', false);
    case REFRESH_BATTERY_SUCCESS:
      return state
        .setIn(['vehicle', 'isConnected'], action.payload.isConnected)
        .setIn(['vehicle', 'batteryLevel'], action.payload.batteryLevel)
        .setIn(['vehicle', 'connectedBatteryLevel'], action.payload.connectedBatteryLevel)
        .setIn(['vehicle', 'batteryLevelDate'], action.payload.batteryLevelDate)
        .set('refreshBatteryLoading', false);
    case REFRESH_ODOMETER_SUCCESS:
      return state
        .setIn(['vehicle', 'isConnected'], action.payload.isConnected)
        .setIn(['vehicle', 'odometer'], action.payload.odometer)
        .setIn(['vehicle', 'connectedOdometer'], action.payload.connectedOdometer)
        .setIn(['vehicle', 'mileageCalculated'], action.payload.mileageCalculated)
        .setIn(['vehicle', 'mileageCalculatedDate'], action.payload.mileageCalculatedDate)
        .setIn(['vehicle', 'odometerInitial'], action.payload.odometerInitial)
        .setIn(['vehicle', 'odometerInitialDate'], action.payload.odometerInitialDate)
        .setIn(['vehicle', 'odometerStale'], action.payload.odometerStale)
        .set('refreshOdometerLoading', false);
    case REMOVE_DAMAGE_SUCCESS: {
      const damageIndex = state
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        .getIn(['vehicle', 'damages'], [])
        // @ts-expect-error TS(2339): Property 'findIndex' does not exist on type 'unkno... Remove this comment to see the full error message
        .findIndex((damage) => damage.id === action.payload.damageId);
      return state
        .merge({
          loading: false,
          // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
          errors: fromJS({}),
        })
        .deleteIn(['vehicle', 'damages', damageIndex]);
    }
    case REMOVE_DAMAGE_PICTURE_SUCCESS: {
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
      const damages = state.getIn(['vehicle', 'damages'], []) as VehicleDamage[];
      const damageIndex = damages.findIndex((damage) => damage.id === action.payload.damageId);
      const pictureIndex = damages[damageIndex].pictures.findIndex(
        (picture) => picture.id === action.payload.pictureId
      );

      const damagePictures = damages[damageIndex]?.pictures;

      if (damagePictures) {
        damagePictures.pop(pictureIndex);
      }

      const newDamages = damages.map((damage, index) => {
        if (index === damageIndex) {
          return {
            ...damage,
            pictures: damagePictures,
          };
        }
        return damage;
      });

      return state
        .merge({
          loading: false,
          // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
          errors: fromJS({}),
        })
        .setIn(['vehicle', 'damages'], newDamages);
    }
    case REMOVE_FILTER:
      return (
        state
          .set('filters', state.get('filters').delete(action.payload.index))
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('vehicles', fromJS({}))
          .set('offset', DEFAULT_OFFSET)
          .set('total', 0)
      );
    case RESET_VEHICLES_DATA:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('vehicles', fromJS({}));
    case SELECT_VIEW:
      return state
        .set('activeView', action.payload.view)
        .set('offset', DEFAULT_OFFSET)
        .set('filters', action.payload.view ? action.payload.view.get('rules') : fromJS([]))
        .set('columns', action.payload.view ? action.payload.view.get('columns') : fromJS([]));
    case SET_ACTIVE_TAB:
      return state.set('activeTab', action.payload.tab);
    case SET_CALENDAR_START:
      return state.set('calendarStart', action.payload.start);
    case SET_COLUMNS:
      return state.set('columns', fromJS(action.payload.columns));
    case SET_DAMAGES_FAIL:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR));
    case SET_DAMAGES_SUCCESS:
      return state.set('vehicle', VehicleRecord(action.payload.data));
    case SET_ODOMETER_OFFSET_FAIL:
      return (
        state
          .set('loading', false)
          // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
          .set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR))
      );
    case SET_ODOMETER_OFFSET_SUCCESS:
      return state.set('loading', false);
    case SET_SEARCH_QUERY:
      return state.set('offset', DEFAULT_OFFSET).set('searchQuery', fromJS(action.payload.searchQuery));
    case SET_VEHICLE:
      return state.set('vehicle', VehicleRecord(action.payload.vehicle));
    case SET_VEHICLES_OFFSET:
      return state.set('offset', action.payload.offset);
    case START_LOADING:
      return state.set('loading', true);
    case START_LOADING_LIGHT_VEHICLES:
      return state.set('loadingLightVehicles', true);
    case START_LOADING_VEHICLES:
      return state.set('loadingVehicles', true);
    case START_REFRESH_FUEL_LOADING:
      return state.set('refreshFuelLoading', true);
    case START_REFRESH_BATTERY_LOADING:
      return state.set('refreshBatteryLoading', true);
    case START_REFRESH_ODOMETER_LOADING:
      return state.set('refreshOdometerLoading', true);
    case UPDATE_VEHICLE_FAIL:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('errors', fromJS(getIn(action, ['payload', 'errors', 'data']) || GENERIC_ERROR));
    case UPDATE_DAMAGE_SUCCESS: {
      const damageIndex = state
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 2.
        .getIn(['vehicle', 'damages'], [])
        // @ts-expect-error TS(2339): Property 'findIndex' does not exist on type 'unkno... Remove this comment to see the full error message
        .findIndex((damage) => damage.id === action.payload.damage.id);

      return state
        .merge({
          loading: false,
          // @ts-expect-error TS(2322): Type 'Collection<unknown, unknown>' is not assigna... Remove this comment to see the full error message
          errors: fromJS({}),
        })
        .setIn(['vehicle', 'damages', damageIndex], action.payload.damage);
    }
    case UPDATE_VEHICLE_SUCCESS:
      // @ts-expect-error TS(2345): Argument of type 'Collection<unknown, unknown>' is... Remove this comment to see the full error message
      return state.set('vehicle', VehicleRecord(action.payload.newVehicleInfo)).set('errors', fromJS({}));
    case UPDATE_VIEW_SUCCESS: {
      if (action.payload.view.type === ENTITY_IDS_BY_NAME.vehicles) {
        const index = state.get('views').findIndex((view) => view.get('id') === action.payload.view.id);
        const updatedView = fromJS(action.payload.view);

        return state
          .update('views', (views) => views.set(index, updatedView))
          .set('activeView', action.payload.resetDefault ? null : updatedView);
      }
      return state;
    }
    default:
      return state;
  }
}

export default withLatestRequest({
  start: START_LOADING_VEHICLES,
  settle: [GET_VEHICLES_SUCCESS, GET_VEHICLES_FAIL],
  loadingKey: 'loadingVehicles',
})(vehiclesServiceReducer);
